import "@/App.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FALLBACK = "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?auto=format&fit=crop&w=600&q=80";

export default function Addons() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/addons`)
      .then((r) => setList(r.data || []))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0604] text-white" data-testid="addons-page">
      <header className="border-b border-[#3a2a14]/60 bg-[#0d0905]/80 backdrop-blur sticky top-0 z-10">
        <div className="max-w-[1280px] mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#f4d089] text-sm" data-testid="back-home">
            <ArrowLeft size={16} /> Back to Home
          </Link>
          <Link to="/book" className="bg-gradient-to-b from-[#e8c98a] to-[#c8a266] text-[#1a0f06] font-semibold px-5 py-2 rounded-md text-sm" data-testid="addons-book-now">
            Book Now
          </Link>
        </div>
      </header>

      <section className="max-w-[1280px] mx-auto px-5 sm:px-8 py-12">
        <div className="flex items-center gap-3 mb-3">
          <Sparkles size={22} className="text-[#f4d089]" />
          <span className="text-[#f4d089] tracking-[0.2em] text-xs font-semibold">MAKE IT EXTRA SPECIAL</span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl text-white mb-3">All Add-ons</h1>
        <p className="text-[#bfb393] max-w-2xl mb-10">
          Personalise your private screening with curated decor, treats and surprises.
          Every add-on is set up before you arrive — just pick what you love.
        </p>

        {loading ? (
          <div className="text-[#a89878] text-sm">Loading add-ons…</div>
        ) : list.length === 0 ? (
          <div className="border border-[#3a2a14] rounded-xl p-12 text-center text-[#a89878]" data-testid="addons-empty">
            No add-ons available right now. Check back soon!
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="addons-grid">
            {list.map((a) => (
              <article
                key={a.id}
                className="rounded-xl overflow-hidden border border-[#3a2a14]/70 bg-gradient-to-b from-[#14100a] to-[#0d0905] hover:border-[#d4a574]/50 transition group"
                data-testid={`addon-card-${a.id}`}
              >
                <div className="aspect-[4/3] overflow-hidden bg-[#0a0604]">
                  <img
                    src={a.image || FALLBACK}
                    alt={a.name}
                    onError={(e) => { e.currentTarget.src = FALLBACK; }}
                    className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <h3 className="font-display text-xl text-white leading-tight" data-testid={`addon-name-${a.id}`}>{a.name}</h3>
                    <div className="text-[#f4d089] font-semibold whitespace-nowrap" data-testid={`addon-price-${a.id}`}>
                      ₹{Number(a.price || 0).toLocaleString("en-IN")}+
                    </div>
                  </div>
                  {a.description ? (
                    <p className="text-sm text-[#bfb393] leading-relaxed">{a.description}</p>
                  ) : (
                    <p className="text-xs text-[#a89878] italic">Premium add-on for your private screening.</p>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}

        <div className="mt-12 rounded-xl border border-[#3a2a14] bg-[#0d0905] p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <div className="text-white font-semibold mb-1">Ready to plan your vibe?</div>
            <p className="text-sm text-[#bfb393]">Pick your slot and choose any of these add-ons during checkout.</p>
          </div>
          <Link to="/book" className="bg-gradient-to-b from-[#e8c98a] to-[#c8a266] text-[#1a0f06] font-semibold px-6 py-3 rounded-md" data-testid="addons-cta-book">
            Book Screening
          </Link>
        </div>
      </section>
    </div>
  );
}
